import React from "react";
import LegalPage, { useLegalInfo, Val, MissingFieldsBlock } from "./LegalPage";

export default function PrivacyPolicy() {
  const info = useLegalInfo();
  return (
    <LegalPage overline="Document légal" title="Politique de confidentialité">
      <p><strong>Effective :</strong> <Val info={info} k="PRIVACY_POLICY_EFFECTIVE_DATE" /></p>
      <p>
        La présente Politique de confidentialité décrit uniquement la manière dont Maison Beaudette™
        traite les renseignements personnels dans le cadre du service Le Révélateur™. Elle est rédigée
        sur la base du fonctionnement réel de l'application. Aucune valeur n'a été inventée.
        Les points marqués <em>[à confirmer]</em> doivent être validés avant toute publication publique.
      </p>

      <h2>1. Identité et coordonnées</h2>
      <ul>
        <li><strong>Nom commercial :</strong> Maison Beaudette™</li>
        <li><strong>Dénomination sociale légale :</strong> <Val info={info} k="LEGAL_BUSINESS_NAME" /></li>
        <li><strong>Adresse d'affaires :</strong> <Val info={info} k="BUSINESS_ADDRESS" /></li>
        <li><strong>Téléphone :</strong> <Val info={info} k="BUSINESS_PHONE" /></li>
        <li><strong>Courriel de soutien :</strong> <Val info={info} k="SUPPORT_EMAIL" /></li>
        <li><strong>Numéro d'entreprise :</strong> <Val info={info} k="BUSINESS_REGISTRATION_NUMBER" /></li>
      </ul>

      <h2>2. Responsable de la protection des renseignements personnels</h2>
      <p>
        <strong>Personne ou titre responsable :</strong> <Val info={info} k="PRIVACY_OFFICER_NAME_OR_TITLE" />
        <br /><strong>Courriel dédié :</strong> <Val info={info} k="PRIVACY_EMAIL" />
      </p>

      <h2>3. Renseignements réellement recueillis</h2>
      <p>Nous collectons uniquement les renseignements suivants, fournis directement par vous :</p>
      <ul>
        <li>Nom du dirigeant ou de la dirigeante (facultatif)</li>
        <li>Nom de l'entreprise</li>
        <li>Adresse courriel professionnelle</li>
        <li>Numéro de téléphone (facultatif)</li>
        <li>Secteur d'activité et taille de l'entreprise (facultatifs)</li>
        <li>Site web (facultatif)</li>
        <li>Vos réponses au questionnaire Le Révélateur™ (23 questions : 18 fermées à choix situationnels, 5 ouvertes)</li>
      </ul>
      <p>
        <strong>Renseignements générés :</strong> à partir de vos réponses, la plateforme produit un rapport
        éditorial (Rapport de Révélation Stratégique™) sous forme de texte et de PDF.
      </p>

      <h2>4. Finalités de la collecte</h2>
      <ul>
        <li>Traiter votre achat (49 $ CA) et vous donner accès au Révélateur™.</li>
        <li>Générer votre Rapport de Révélation Stratégique™ personnalisé.</li>
        <li>Vous transmettre les courriels transactionnels (confirmation, lien privé de votre rapport).</li>
        <li>Répondre à vos demandes de soutien.</li>
        <li>Vous envoyer, uniquement si vous y avez consenti explicitement, les communications marketing de Maison Beaudette™.</li>
      </ul>

      <h2>5. Traitement du paiement</h2>
      <p>
        Le paiement est traité par Stripe. Maison Beaudette™ ne conserve pas votre numéro de carte ni les
        renseignements bancaires complets. Seul un identifiant de transaction non sensible est enregistré
        pour permettre le rapprochement comptable.
      </p>

      <h2>6. Fournisseurs réellement utilisés</h2>
      <ul>
        <li><strong>Paiement :</strong> Stripe (traitement du 49 $ CA, carte bancaire).</li>
        <li><strong>Envoi de courriels :</strong> Resend (courriels transactionnels).</li>
        <li>
          <strong>Personnalisation par intelligence artificielle :</strong> le modèle Anthropic Claude est utilisé,
          via la clé universelle Emergent, pour rédiger la portion éditoriale de votre rapport à partir de vos réponses.
          Vos réponses sont transmises au modèle uniquement le temps de générer le texte du rapport.
        </li>
        <li><strong>Base de données :</strong> MongoDB (hébergée sur l'infrastructure Emergent).</li>
      </ul>
      <p>
        <strong>Traitement possible hors Québec ou hors Canada :</strong> certains de ces fournisseurs peuvent
        traiter les renseignements hors du Canada. Toute mise à jour précise des juridictions concernées sera
        confirmée avant publication publique.
      </p>

      <h2>7. Utilisation réelle d'un modèle d'intelligence artificielle</h2>
      <p>
        La personnalisation du rapport repose sur un modèle Anthropic Claude. Les extraits de vos réponses transmis
        au modèle servent exclusivement à produire le contenu éditorial du Rapport de Révélation Stratégique™.
        Aucun profil publicitaire n'est constitué à partir de ces échanges.
      </p>

      <h2>8. Analytique et témoins réellement installés</h2>
      <p>
        À ce jour, aucun traceur publicitaire non essentiel (Meta Pixel, Google Analytics, TikTok Pixel, LinkedIn
        Insight Tag, etc.) n'est présent dans l'application. Voir la <a href="/politique-des-temoins">Politique des témoins</a>.
      </p>

      <h2>9. Personnes ou catégories ayant accès à vos données</h2>
      <ul>
        <li>Personnel autorisé de Maison Beaudette™.</li>
        <li>Fournisseurs listés à la section 6, uniquement pour les finalités décrites.</li>
      </ul>

      <h2>10. Conservation des renseignements</h2>
      <ul>
        <li><strong>Renseignements personnels :</strong> <Val info={info} k="PERSONAL_DATA_RETENTION_PERIOD" /></li>
        <li><strong>Rapports générés :</strong> <Val info={info} k="REPORT_RETENTION_PERIOD" /></li>
        <li><strong>Comptes :</strong> <Val info={info} k="ACCOUNT_RETENTION_PERIOD" /></li>
        <li><strong>Données d'analytique :</strong> <Val info={info} k="ANALYTICS_RETENTION_PERIOD" /></li>
      </ul>

      <h2>11. Mesures de sécurité</h2>
      <p>
        Les communications entre votre navigateur et la plateforme utilisent HTTPS. L'accès aux comptes et
        aux bases de données est restreint au personnel autorisé. Nous n'affirmons pas que les données sont
        chiffrées au repos si cela n'a pas été confirmé formellement. Les mesures techniques et organisationnelles
        précises seront documentées avant publication publique.
      </p>

      <h2>12. Vos droits</h2>
      <ul>
        <li>Droit d'accès à vos renseignements personnels.</li>
        <li>Droit de rectification.</li>
        <li>Droit de retirer votre consentement à toute communication marketing, à tout moment.</li>
        <li>Droit de demander la suppression de vos données, sous réserve des obligations légales de conservation.</li>
        <li>Droit de porter plainte auprès de l'autorité compétente.</li>
      </ul>
      <p>
        Pour exercer ces droits ou déposer une plainte, écrivez au responsable désigné à la section 2
        (ou, à défaut, au courriel de soutien indiqué à la section 1). Nous vous répondrons dans un délai raisonnable.
      </p>

      <h2>13. Avis relatif au questionnaire</h2>
      <p>
        Vos réponses servent à générer votre lecture stratégique. Évitez d'inscrire des mots de passe, des numéros
        de carte, des renseignements gouvernementaux, des données médicales ou des renseignements confidentiels
        concernant une autre personne.
      </p>

      <h2>14. Modifications</h2>
      <p>
        La présente politique peut évoluer. La date d'entrée en vigueur ci-dessus indique la version applicable.
      </p>

      <MissingFieldsBlock info={info} />
    </LegalPage>
  );
}
